namespace RioERP.Masters {
    export interface CurrenciesForm {
        Name: Serenity.StringEditor;
        CurrencyCode: Serenity.StringEditor;
        InrRate: Serenity.DecimalEditor;
        IsDefault: Serenity.BooleanEditor;
    }

    export class CurrenciesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.Currencies';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CurrenciesForm.init)  {
                CurrenciesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(CurrenciesForm, [
                    'Name', w0,
                    'CurrencyCode', w0,
                    'InrRate', w1,
                    'IsDefault', w2
                ]);
            }
        }
    }
}
